import { render, staticRenderFns } from "./PopupMap.vue?vue&type=template&id=2987daf4&scoped=true&"
import script from "./PopupMap.vue?vue&type=script&lang=js&"
export * from "./PopupMap.vue?vue&type=script&lang=js&"
import style0 from "./PopupMap.vue?vue&type=style&index=0&id=2987daf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987daf4",
  null
  
)

export default component.exports